(function () {
  'use strict';

  function requestDemoSmallController($scope, requestDemoDataService, STATES_LIST) {

    var vm = this;
    vm.states = STATES_LIST;
    vm.model = {};
    vm.isSuccess = false;
    vm.errors = [];
    vm.submit = function() {
      vm.hideButtons = true;
      if (!vm.model.State) {
        vm.errors = ["State is missing"];
        return;
      }

      return requestDemoDataService.requestDemo(vm.model).then(
        function (result) {
          if (result.Errors && result.Errors.length > 0) {
            vm.errors = result.Errors;
            vm.hideButtons = false;
          }
          else {
            vm.hideButtons = true;
            vm.errors = [];
            vm.isSuccess = true;
          }
        }
      )
    }
  }

  requestDemoSmallController.$inject = [
    '$scope', 'requestDemoDataService', 'STATES_LIST'
  ];

  angular.module('ecap.registration').controller('requestDemoSmallController', requestDemoSmallController);
})();